







































import Vue from "vue";
// import Cookie from "js-cookie";
export default Vue.extend({
  data() {
    return {
      fixed: false,
      bannerPosition: 0,
    };
  },
  computed: {
    getLogo() {
      return this.$isPc
        ? require("@/assets/images/nav-logo.png")
        : require("@/assets/images/nav-logo_m.png");
    },
  },
  created() {},
  methods: {
    handleApplyTrial() {
      this.$router.push({ name: "applyTrial" });
    },
    handleLogin() {
      // let role = Cookie.get("web_user_role");
      // switch (role) {
      //   case "1":
      //     window.location.href = process.env.VUE_APP_EDU_URL;
      //     break;
      //   case "2":
      //     window.location.href = process.env.VUE_APP_HR_URL;
      //     break;
      //   default:
      this.$router.push({ name: "companyLogin" });
      // }
    },
  },
});
